import apiClient from '@/services/apiClient'

export interface MaintenanceStatus {
  maintenance: boolean
  message: string
  /** Whether the in-portal live chat should load (admin toggle). Defaults on. */
  chatEnabled: boolean
}

interface MaintenanceResponse {
  data: { maintenance: boolean; message: string; chat_enabled?: boolean }
}

/**
 * Whether the portal is offline for maintenance.
 *
 * Public, so it answers before a customer signs in and stays reachable while
 * maintenance is on: it is what lets the app show the notice instead of the
 * login form. Read once at startup by MaintenanceGate.
 */
export const maintenanceService = {
  async getStatus(): Promise<MaintenanceStatus> {
    const response = (await apiClient.get('/api/maintenance')) as unknown as MaintenanceResponse

    return {
      maintenance: !!response.data?.maintenance,
      message: response.data?.message ?? '',
      // Default on if the flag is missing, so a customer never loses chat over
      // a stale build or a partial response.
      chatEnabled: response.data?.chat_enabled !== false,
    }
  },
}

export default maintenanceService
